/**
 * Created by guntherclaes on 03/04/2017.
 */
/* global angular*/
require('./vsko-alert');
require('./vsko-app-popover');
require('./vsko-avatar');
require('./vsko-block-list');
require('./vsko-bordered-list');
require('./vsko-button');
require('./vsko-button-group');
require('./vsko-button-toolbar');
require('./vsko-card');
require('./vsko-code-example');
require('./vsko-content');
require('./vsko-dropdown');
require('./vsko-grid');
require('./vsko-icon');
require('./vsko-label');
require('./vsko-loading-bar');
require('./vsko-nav');
require('./vsko-panel');
require('./vsko-pagination');
require('./vsko-progress-bar');
require('./vsko-spinner');
require('./vsko-tag');
require('./vsko-table');
require('./vsko-toolbar');
require('./vsko-tooltip');
require('./vsko-logo');
require('./vsko-modal');
require('./vsko-input');
require('./vsko-text-area');
require('./vsko-select');
require('./vsko-radio-group');
require('./vsko-checkbox');
require('./vsko-password');
require('./vsko-file');
require('./vsko-input-group');
require('./vsko-color-input');
require('./vsko-date-picker');

var module = angular.module('@kathondvla/style', [
  'vskoAlert',
  'vskoAppPopover',
  'vskoAvatar',
  'vskoBlockList',
  'vskoBorderedList',
  'vskoButton',
  'vskoButtonGroup',
  'vskoButtonToolbar',
  'vskoCard',
  'vskoCodeExample',
  'vskoContent',
  'vskoDropdown',
  'vskoGrid',
  'vskoIcon',
  'vskoLabel',
  'vskoLoadingBar',
  'vskoNav',
  'vskoPanel',
  'vskoPagination',
  'vskoProgressBar',
  'vskoSpinner',
  'vskoTag',
  'vskoTable',
  'vskoToolbar',
  'vskoTooltip',
  'vskoLogo',
  'vskoModal',
  'vskoInput',
  'vskoTextArea',
  'vskoSelect',
  'vskoRadioGroup',
  'vskoCheckbox',
  'vskoPassword',
  'vskoFile',
  'vskoInputGroup',
  'vskoColorInput',
  'vskoDatePicker',
  require('angular-ui-bootstrap')
]);

module.factory('vskoModalService', ['$uibModal', '$document', function($uibModal, $document) {
  var SIZES = [{id: 'small', css: 'sm'}, {id: 'medium', css: 'md'}, {id: 'large', css: 'lg'}];

  var openModal = function(modalOptions) {
    var parent = $document.find(modalOptions.appendTo || 'body').eq(0);
    var sizeArray = $.grep(SIZES, function(e) { return e.id == modalOptions.size; });
    var size = sizeArray.length > 0 ? sizeArray[0].css : 'lg';

    var options = {
      appendTo: parent,
      size: size,
      backdrop: 'static',
      template: modalOptions.template,
      templateUrl: modalOptions.templateUrl,
      animation: modalOptions.animation || true,
      ariaDescribedBy: modalOptions.ariaDescribedBy || 'my-modal-description',
      ariaLabelledBy: modalOptions.ariaLabelledBy || 'my-modal-title',
      controller: modalOptions.controller || function() {},
      controllerAs: '$ctrl',
      resolve: modalOptions.resolve || function() {},
      scope: modalOptions.scope || null
    };
    return $uibModal.open(options);
  };

  return {
    open: function(modalOptions) {
      return openModal(modalOptions);
    }
  }
}]);

module.value('_', require('lodash'));
